export default __webpack_public_path__ + "static/media/token_sentiment.bda5ce26.svg";